// removed by extract-text-webpack-plugin
module.exports = {"base":"Option_base--1XONE","base__level":"Option_base__level--39Kt0","baseLevel":"Option_base__level--39Kt0","base__duration":"Option_base__duration--1FcvE","baseDuration":"Option_base__duration--1FcvE","base__players":"Option_base__players--rqMon","basePlayers":"Option_base__players--rqMon","base__legionaries":"Option_base__legionaries--1nlp5","baseLegionaries":"Option_base__legionaries--1nlp5"};


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Option/Option.scss
// module id = 500
// module chunks = 11 12